import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { BangumiProviderConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BangumiProviderApiModule {
    public static forRoot(configurationFactory: () => BangumiProviderConfiguration): ModuleWithProviders<BangumiProviderApiModule> {
        return {
            ngModule: BangumiProviderApiModule,
            providers: [ { provide: BangumiProviderConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BangumiProviderApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BangumiProviderApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
